module.exports = __WEBPACK_EXTERNAL_MODULE_45__;


/*****************
 ** WEBPACK FOOTER
 ** external {"amd":"exports","commonjs":"dom-storage","commonjs2":"dom-storage","root":"localStorage"}
 ** module id = 45
 ** module chunks = 0
 **/